import type { PropSchema } from '@blocknote/core';

/**
 * BlockNote prop schema for the `dropdown` block. Kept as a standalone const so
 * both the spec (`dropdown-block.tsx`, runtime value) and the renderer
 * (`dropdown-block-renderer.tsx`, `typeof` for its render-props type) share one
 * source of truth for the block's props.
 */
export const dropdownBlockPropSchema = {
  // The selected value
  value: {
    default: '',
  },
  // Available options (stored as JSON string)
  options: {
    default: '[]',
  },
  // Label/placeholder text
  label: {
    default: 'Select an option',
  },
} satisfies PropSchema;
